import { fixItemHomeLowcaseBug, getParent } from 'reactApp/modules/file/utils';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { renameCameraUploadFolder } from 'reactApp/utils/tree.helpers';

import type { SharedAutoDeleteFolder } from './sharedAutoDelete.type';

/**
 * При создании автоудаляемой папки бэк в ответ не отдает данные о ней,
 * поэтому заполняем их на фронте, чтобы лишний раз не спрашивать эти данные у сервера
 * @param item - автоудаляемая папка
 * @returns "правильная" автоудаляемая папка
 */
export function normalizeAutoDeleteFolder(item): SharedAutoDeleteFolder {
    const fixedHome = fixItemHomeLowcaseBug(item.home, item.name);
    const parentFolder = getParent(fixedHome);

    return {
        ...item,
        __reduxTree: true,
        // Приводим к toLowerCase для совместимости со списком папок, которые пришли с бэка
        id: fixedHome.toLowerCase(),
        parent: parentFolder,
        name: renameCameraUploadFolder(item),
        size: item.size,
        type: 'folder',
        home: fixedHome,
        storage: EStorageType.sharedAutodelete,
        tree: item.tree || '',
        rev: item.rev || 0,
        kind: item.kind,
        isFolder: true,
        childs: [],
    };
}
